module.exports = __webpack_public_path__ + "img/apple_logo_icon_168588 1.2e0130b4.png";